<template>
  <div class="lg:px-8">
    <div class="max-w-7xl mx-auto w-full">
      <div class="py-10 flex flex-col justify-center gap-5">
        <div class="flex items-center justify-center px-5 lg:px-0">
          <div class="flex-grow border-t-2 border-black"></div>
          <h2
            class="px-4 lg:text-3xl text-[#001c54] uppercase text-center hidden lg:block"
          >
            COLLABORATION WITH LEADING GLOBAL PROFESSIONAL BODIES
          </h2>
          <h2
            class="px-4 text-[21px] text-[#001c54] uppercase text-center block lg:hidden"
          >
            Collaborations with <br />
            Leading Global <br />
            Professional
          </h2>
          <div class="flex-grow border-t-2 border-black"></div>
        </div>
        <div class="relative w-full">
          <div
            class="absolute bottom-0 right-0 top-[45px] md:top-[45%] md:right-0 z-10 cursor-pointer"
          >
            <img
              src="@/assets/MbaFinance/right-arrow.png"
              class="nextcollabs w-[30px] h-[30px]"
              width="30px"
              height="40px"
              alt=""
            />
          </div>
          <div class="w-full max-w-6xl mx-auto">
            <div class="flex justify-between mt-5 slick_collabs px-8 xl:px-0">
              <div
                v-for="global in globals"
                :key="global.id"
                class="flex justify-center items-center"
              >
                <div
                  class="flex gap-4 justify-center items-center bg-white border shadow rounded-md hidden md:block"
                >
                  <img
                    :src="global.imgDes"
                    alt="company logo"
                    class="md:w-full md:h-[120px] object-contain rounded-xl"
                  />
                </div>

                <div
                  class="flex gap-4 justify-center items-center bg-white border rounded-md md:hidden block"
                >
                  <img
                    :src="global.imgMob"
                    alt="company logo"
                    class="w-full h-[80px] object-contain rounded-xl"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="absolute bottom-0 left-0 top-[45px] md:top-[45%] z-10 cursor-pointer"
          >
            <img
              src="@/assets/MbaFinance/left-arrow.png"
              width="30px"
              height="40px"
              class="prevcollabs"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "CollaborationsView",
  data() {
    return {
      globals: [
        {
          id: 1,
          imgDes: require("@/assets/LPnew/images/collabs/collabsImg1.png"),
          imgMob: require("@/assets/LPnew/images/collabs/collabsImg1.png"),
        },
        {
          id: 2,
          imgDes: require("@/assets/LPnew/images/collabs/collabsImg2.png"),
          imgMob: require("@/assets/LPnew/images/collabs/collabsImg2.png"),
        },
        {
          id: 3,
          imgDes: require("@/assets/LPnew/images/collabs/collabsImg3.png"),
          imgMob: require("@/assets/LPnew/images/collabs/collabsImg3.png"),
        },
        {
          id: 4,
          imgDes: require("@/assets/LPnew/images/collabs/collabsImg4.png"),
          imgMob: require("@/assets/LPnew/images/collabs/collabsImg4.png"),
        },
        {
          id: 4,
          imgDes: require("@/assets/LPnew/images/collabs/collabsImg5.png"),
          imgMob: require("@/assets/LPnew/images/collabs/collabsImg5.png"),
        },
      ],
    };
  },
  mounted() {
    $(`.slick_collabs`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: $(".prevcollabs"),
      nextArrow: $(".nextcollabs"),
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,

      responsive: [
        {
          breakpoint: 1026,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style></style>
